export const deepEqual = (obj1: any, obj2: any): boolean => {
  if (obj1 === obj2) {
    return true; // 같은 객체이거나 둘 다 null, undefined, NaN 같은 경우
  }

  if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false; // 둘 중 하나가 null이거나 객체가 아닌 경우
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false; // 속성의 개수가 다른 경우
  }

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false; // 속성이 없거나 속성의 값이 다른 경우
    }
  }

  return true;
};
